const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
]

export function convertSymbolToType(symbol) {
  if (symbol === "%") return "percentage"
  if (symbol === "$") return "amount"
}

export function convertTypeToSymbol(type) {
  type = type.toLowerCase()
  if (type === "percentage") return "%"
  if (type === "percent") return "%"
  if (type === "amount") return "$"
}

export function currencyFormat(amount, defaultValue = 0, maxFractionDigits = 4) {
  if (amount === undefined || amount === null) return defaultValue

  // Convert the amount to a number and ensure it's valid
  let numericAmount = Number(amount)
  if (isNaN(numericAmount)) return defaultValue

  // Split integer and decimal parts
  let [integerPart, decimalPart] = numericAmount.toFixed(maxFractionDigits).split(".")

  // Format the integer part with commas
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",")

  // Remove trailing zeros in the decimal part
  decimalPart = decimalPart.replace(/0+$/, "")

  // Return formatted number
  return decimalPart ? `${integerPart}.${decimalPart}` : integerPart
}

// export function currencyFormat(amount, defaultValue = 0, maxFractionDigits = 0) {
//
//   if (amount === undefined || amount === null)
//     return defaultValue;
//
//   // Convert the amount to a string.
//   let amountString = amount.toString();
//
//   // Split the string into the integer and decimal parts.
//   let [integerPart, decimalPart] = amountString.split('.');
//
//   // If there is a decimal part and it's longer than two digits, truncate it.
//   if (decimalPart && decimalPart.length > 2) {
//     decimalPart = decimalPart.substring(0, 2);
//   }
//
//   // Format the integer part with commas.
//   integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//
//
//   // Add zeros to the decimal part if it doesn't exist but maxFractionDigits is greater than 0.
//   if (!decimalPart && maxFractionDigits > 0) {
//     decimalPart = '0'.repeat(maxFractionDigits);
//   } else if (decimalPart && decimalPart.length < maxFractionDigits) {
//     // Add trailing zeros to the decimal part if its length is less than maxFractionDigits.
//     decimalPart = decimalPart + '0'.repeat(maxFractionDigits - decimalPart.length);
//   }
//
//   // Combine the integer part and decimal part if decimal exists and is not '00' or '0'.
//   if ((decimalPart && !/^0+$/g.test(decimalPart)) || (decimalPart && maxFractionDigits != 0)) {
//     return integerPart + '.' + decimalPart;
//   } else {
//     return integerPart;
//   }
//
// }

export function applyFunctionToObject(item, func, excludedKeys = []) {
  for (const key in item) {
    if (!excludedKeys.includes(key)) {
      if (typeof item[key] === "number" || isStringOnlyNumbers(item[key])) {
        item[key] = func(item[key])
      } else if (typeof item[key] === "object") {
        applyFunctionToObject(item[key], func, excludedKeys)
      }
    }
  }
}

export function applyFunctionToNumbers(array, func, excludedKeys = []) {
  for (const item of array) {
    applyFunctionToObject(item, func, excludedKeys)
  }
}

export function applyFunctionToStrings(array, func, keys = []) {
  for (const item of array) {
    applyFunctionToObjectString(item, func, keys)
  }
}

export function applyFunctionToObjectString(item, func, keys = []) {
  for (const key in item) {
    if (keys.includes(key)) {
      item[key] = func(item[key])
    }
  }
}

export function isStringOnlyNumbers(inputString) {
  return /^(\d+|\d*\.\d+|\.\d+)$/.test(inputString)
}

export function removeCurrencyFormat(amount, defaultValue = 0) {
  if (!amount) return defaultValue
  const temp = "" + amount
  return temp.replace(/[^0-9.]|(?:\..*)\./g, "")
}

export function formatDateFromServer(date, isDateTime = true) {
  if (date) {
    // FORMAT: Mon dd, yyyy, hh:mm AM
    const d = new Date(date)

    const year = d.getFullYear()
    const month = monthNames[d.getMonth()].substring(0, 3)
    const day = String(d.getDate()).padStart(2, "0")
    const period = hour > 12 ? "PM" : "AM"
    const hour = String(d.getHours() > 12 ? d.getHours() - 12 : d.getHours()).padStart(2, "0")
    const minute = String(d.getMinutes()).padStart(2, "0")

    const formatedDate = `${month} ${day}, ${year}`
    const formatedTime = `${hour}:${minute} ${period}`

    return formatedDate + (isDateTime ? `, ${formatedTime}` : "")
  }
  return ""
}

export function formatDateForServer(inputDate, isDateTime = true) {
  // Get the date string in local time
  const localDateString = new Date(inputDate).toLocaleString("en-US", {
    timeZone: "America/Los_Angeles", // Set timezone to California
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour12: false, // Use 24-hour format
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  })

  // Split the date and time components
  const [date, time] = localDateString.split(", ")

  // Format the date and time separately
  const [month, day, year] = date.split("/")
  const [hour, minute, second] = time.split(":")

  // Construct the formatted date string
  const formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`

  // Construct the formatted time string
  const formattedTime = `${hour.padStart(2, "0")}:${minute.padStart(2, "0")}:${second.padStart(2, "0")}`

  // Return the formatted date and time
  return isDateTime ? `${formattedDate} ${formattedTime}` : formattedDate
}


export function getDateRange(dateName = "today", toISOString = true) {
  // Get the current date in the California timezone
  const currentDateCalifornia = new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
// Convert the date string to a Date object
  const today = new Date(currentDateCalifornia)

  let daterange = {}

  const dayOfWeek = today.getDay()

  // Calculate the difference in days to go back to the last Monday
  const daysToMonday = (dayOfWeek === 0) ? 6 : (dayOfWeek - 1)


  switch (dateName) {
    case "today":
      daterange["startDate"] = daterange["endDate"] = today
      break

    case "yesterday":
      today.setDate(today.getDate() - 1)
      daterange["startDate"] = daterange["endDate"] = today
      break

    case "lastWeek":

      const lastMonday = new Date(today)
      lastMonday.setDate(today.getDate() - daysToMonday)

      // Set the start date of the last week to last Monday
      const startDate = new Date(lastMonday)
      startDate.setDate(lastMonday.getDate() - 7)

      // Set the end date of the last week to last Sunday
      const endDate = new Date(lastMonday)
      endDate.setDate(lastMonday.getDate() - 1)

      // Adjust the dates back to UTC if needed
      const startDateUTC = new Date(startDate.getTime() + (8 * 60 * 60 * 1000))
      const endDateUTC = new Date(endDate.getTime() + (8 * 60 * 60 * 1000))

      daterange["startDate"] = startDateUTC
      daterange["endDate"] = endDateUTC
      break

    case "thisWeek":

      const mondayOfCurrentWeek = new Date(today)
      mondayOfCurrentWeek.setDate(today.getDate() - daysToMonday)

      // Calculate the start and end dates of the current week (Monday to Sunday)
      const thisWeekStartDate = new Date(mondayOfCurrentWeek)
      const thisWeekEndDate = new Date(mondayOfCurrentWeek)
      thisWeekEndDate.setDate(mondayOfCurrentWeek.getDate() + 6)

      // Adjust the dates back to UTC if needed
      const thisWeekStartDateUTC = new Date(thisWeekStartDate.getTime() + (8 * 60 * 60 * 1000))
      const thisWeekEndDateUTC = new Date(thisWeekEndDate.getTime() + (8 * 60 * 60 * 1000))

      daterange["startDate"] = thisWeekStartDateUTC
      daterange["endDate"] = thisWeekEndDateUTC
      break

    case "lastMonth":
      daterange["startDate"] = new Date(today.getFullYear(), today.getMonth() - 1, 1)
      daterange["endDate"] = new Date(today.getFullYear(), today.getMonth(), 0)
      break

    case "thisMonth":
      daterange["startDate"] = new Date(today.getFullYear(), today.getMonth(), 1)
      daterange["endDate"] = new Date(today.getFullYear(), today.getMonth() + 1, 0)
      break

    case "lastYear":
      daterange["startDate"] = new Date(today.getFullYear() - 1, 0, 1)
      daterange["endDate"] = new Date(today.getFullYear() - 1, 11, 31)
      break

    case "thisYear":
      daterange["startDate"] = new Date(today.getFullYear(), 0, 1)
      daterange["endDate"] = new Date(today.getFullYear(), 11, 31)
      break

    default:
      daterange = {}
      break
  }

  if (daterange !== {}) {
    if (toISOString) {
      daterange.startDate = daterange.startDate.toISOString().split("T")[0]
      daterange.endDate = daterange.endDate.toISOString().split("T")[0]
    }
  }
  return daterange
}
